import {ratingsReviewSrcAdaptor} from '../ratings-review-utils';
import {aboutHotelTemplate} from './categoryTemplate';

const transformGiData = ratingSummaryGI => {
  const transformedGiData = {};

  ratingSummaryGI?.forEach(category => {
    if (!!category?.value) {
      transformedGiData[category.concept + '_per'] = category.value;
    }
    category?.tags?.forEach(subCategory => {
      if (!!subCategory?.value) {
        const subCategoryTitle = subCategory.name.toLowerCase().replace(' ', '-');
        transformedGiData[category.concept + '_' + subCategoryTitle + '_per'] = subCategory.value;
      }
    });
  });
  return transformedGiData;
};

const replacePlaceholders = (baseString, transformedData) => {
  let baseFlag = true;
  const placeholderRegex = /{([^}]+)}/g;

  const newString = baseString.replace(placeholderRegex, function (match, placeholder) {
    if (transformedData[placeholder] === undefined) {
      baseFlag = false;
      return '';
    }
    return transformedData[placeholder];
  });
  return baseFlag ? newString : null;
};

export const getSeoAboutDescription = (
  propertyName,
  propertyType,
  ugcSummaryGIData,
  countryCode,
) => {
  try {
    if (!ugcSummaryGIData) {
      return '';
    }

    const {
      ratingCount,
      cumulativeRating,
      recommendationPercent,
      ratingBreakup = {},
      subConcepts = [],
      ratingSummaryGI,
    } = ugcSummaryGIData;

    if (ratingCount === 0) {
      return '';
    }
    const posTags = subConcepts
      ?.filter(tag => tag?.sentiment?.toLowerCase() === 'positive')
      .map(tag => tag.displayText)
      .slice(0, 5)
      .join(', ');

    const recommendationString =
      recommendationPercent > 0 && recommendationPercent < 85
        ? `${recommendationPercent}% of the guests have recommended ${propertyName} on our platform. `
        : '';
    const tagsString = posTags?.length ? `Guests love this hotel for its ${posTags}. ` : '';
    let ratingString = '';
    let overallRatingString = '';

    if (Object.keys(ratingBreakup).length) {
      const raingObj = {};

      for (const [key, value] of Object.entries(ratingBreakup)) {
        console.log(`${key}: ${value}`);
        raingObj[`${key} star`] = value;
      }

      const vgoodPercentage = (raingObj['5 star'] * 100) / ratingCount;
      const goodPercentage = (raingObj['4 star'] * 100) / ratingCount;
      const averagePercentage = (raingObj['3 star'] * 100) / ratingCount;
      const badPercentage = 100 - (vgoodPercentage + goodPercentage + averagePercentage);

      overallRatingString = `With an impressive ${cumulativeRating} out of 5 rating from ${ratingCount} reviews, it’s a favourite among travellers.<br />Here’s what guests have to say:<br /><br />`;
      const vgoodPercentageString = vgoodPercentage
        ? `*${Math.round(vgoodPercentage)}% found their stay excellent, praising the comfort and hospitality.<br />`
        : '';
      const goodPercentageString = goodPercentage
        ? `*${Math.round(goodPercentage)}% rated it good, appreciating the service and amenities.<br />`
        : '';
      const averagePercentageString = averagePercentage
        ? `*${Math.round(averagePercentage)}% felt it was average, mentioning room for improvement.<br />`
        : '';
      const badPercentageString = badPercentage
        ? `*${Math.round(badPercentage)}% had a below-expectations experience, highlighting specific concerns.<br />`
        : '';

      ratingString = `<p>${vgoodPercentageString}${goodPercentageString}${averagePercentageString}${badPercentageString}</p>`;
    }

    const categoryTextArray = [];
    const transformedData = transformGiData(ratingSummaryGI);

    if (!!propertyName) {
      transformedData['hotel_name'] = propertyName;
    }

    Object.keys(aboutHotelTemplate).forEach(key => {
      const headingText = aboutHotelTemplate[key].heading;
      const catText = replacePlaceholders(aboutHotelTemplate[key].cat_text, transformedData);
      if (!!catText) {
        if (!!headingText) {
          categoryTextArray.push(headingText);
        }
        categoryTextArray.push(catText);
      }
      Object.keys(aboutHotelTemplate[key].sub_catg_text).forEach(subKey => {
        const subCatText = replacePlaceholders(
          aboutHotelTemplate[key].sub_catg_text[subKey],
          transformedData,
        );
        if (!!subCatText) {
          categoryTextArray.push(subCatText);
        }
      });
    });

    const categoryText = categoryTextArray.join('');

    return `${recommendationString}${tagsString}${overallRatingString}${ratingString}${categoryText}`;
  } catch (ex) {
    console.error('Error in getSeoAboutDescription: ', ex);
    return '';
  }
};
